var map = {
	"./BaseType.js": [
		"549f",
		"chunk-2d0c8322"
	],
	"./HyperPay.js": [
		"df11",
		"chunk-368855c2"
	],
	"./MasterCard.js": [
		"a773",
		"chunk-368c6f62"
	],
	"./Noon.js": [
		"4d24",
		"chunk-36b40822"
	],
	"./Urway.js": [
		"51e2",
		"chunk-36b491f4"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "4f0c";
module.exports = webpackAsyncContext;